// extracted by mini-css-extract-plugin
export default {"lg":"Text_lg__fJUpQ","md":"Text_md__OlZef","sm":"Text_sm__bwl9A","xsm":"Text_xsm__J9cP7","ellipsis":"Text_ellipsis__KOait"};